import React from 'react';

const Loading = () => {
  return (
    <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', height: '100vh', alignItems:'center' }}>
      <img alt="" style={{ textAlign: 'center' }} height={100} width={100} src="https://res.cloudinary.com/tech-qalanders/image/upload/v1618305944/chex-instruction/chex-circle_1_o2tjf9.gif" />
    </div>
  );
};

export default Loading;
